function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1988(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25.43,
    height: 9.85,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.23125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 4.925
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.85,
    width: 25.43,
    height: 21.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.68875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 20.605
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.36,
    width: 25.43,
    height: 26.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 44.835
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.32,
    width: 25.43,
    height: 30.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 73.375
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.43,
    width: 25.43,
    height: 37.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8255555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 107.05000000000001
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 125.67,
    width: 25.43,
    height: 40.31,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 145.825
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 165.98,
    width: 25.43,
    height: 44.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.632857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 188.05499999999998
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 210.13,
    width: 25.43,
    height: 44.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.632857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 232.49
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.85,
    width: 25.43,
    height: 50.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.086
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 280.265
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.68,
    width: 25.43,
    height: 51.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 331.21500000000003
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.75,
    width: 25.43,
    height: 52.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 382.93
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 409.11,
    width: 25.43,
    height: 55.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 436.985
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 464.86,
    width: 25.43,
    height: 56.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 493.095
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.32,
    width: 25.43,
    height: 57.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 550.0150000000001
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 578.71,
    width: 25.43,
    height: 59.12,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 608.27
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 637.83,
    width: 25.43,
    height: 62.17,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.715,
    y: 668.9150000000001
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 0,
    width: 35.47,
    height: 44.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.093999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.165,
    y: 22.305
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.91,
    y: 0,
    width: 38.13,
    height: 44.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.813
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.975,
    y: 22.305
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.04,
    y: 0,
    width: 38.42,
    height: 44.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.842
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.25,
    y: 22.305
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.46,
    y: 0,
    width: 40.13,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.013
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.525,
    y: 22.305
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 0,
    width: 41.21,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.887142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.195,
    y: 22.305
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.8,
    y: 0,
    width: 41.21,
    height: 44.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.868333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.405,
    y: 22.305
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.02,
    y: 0,
    width: 41.7,
    height: 44.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.87,
    y: 22.305
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.72,
    y: 0,
    width: 43.62,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.231428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.53000000000003,
    y: 22.305
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.34,
    y: 0,
    width: 45.6,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.57625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 368.14,
    y: 22.305
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.93,
    y: 0,
    width: 46.69,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.57625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.275,
    y: 22.305
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.62,
    y: 0,
    width: 47.46,
    height: 44.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.57625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.35,
    y: 22.305
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.08,
    y: 0,
    width: 48.37,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.372857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.265,
    y: 22.305
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.46,
    y: 0,
    width: 54.68,
    height: 44.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.8000000000001,
    y: 22.305
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 588.14,
    y: 0,
    width: 54.92,
    height: 44.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.055454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.6,
    y: 22.305
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.06,
    y: 0,
    width: 56.94,
    height: 44.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.956666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.53,
    y: 22.305
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 44.61,
    width: 58.02,
    height: 44.15,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 66.685
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 88.76,
    width: 58.02,
    height: 47.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 112.525
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 136.29,
    width: 58.02,
    height: 47.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.97375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 160.185
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 184.08,
    width: 58.02,
    height: 48.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.908571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 208.26000000000002
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 232.44,
    width: 58.02,
    height: 50.09,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.155714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 257.485
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 282.53,
    width: 58.02,
    height: 51.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.335714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 308.205
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 333.89,
    width: 58.02,
    height: 51.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.284166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 359.59499999999997
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 385.3,
    width: 58.02,
    height: 57.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 414.08500000000004
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 442.87,
    width: 58.02,
    height: 75.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8020000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 480.55
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 518.23,
    width: 58.02,
    height: 90.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.8020000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 563.285
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.43,
    y: 608.34,
    width: 58.02,
    height: 91.66,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.274545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.44,
    y: 654.1700000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.45,
    y: 44.61,
    width: 69.7,
    height: 78.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.616666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.30000000000001,
    y: 83.935
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.15,
    y: 44.61,
    width: 72.81,
    height: 78.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.10125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.555,
    y: 83.935
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225.96,
    y: 44.61,
    width: 83.45,
    height: 78.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.235714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.685,
    y: 83.935
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.41,
    y: 44.61,
    width: 92.57,
    height: 78.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.108333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.69500000000005,
    y: 83.935
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.98,
    y: 44.61,
    width: 97.95,
    height: 78.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.83125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.95500000000004,
    y: 83.935
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.93,
    y: 44.61,
    width: 99.39,
    height: 78.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.108333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.625,
    y: 83.935
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.31,
    y: 44.61,
    width: 100.69,
    height: 78.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.108333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.655,
    y: 83.935
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.45,
    y: 123.26,
    width: 115.84,
    height: 73.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 159.88
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.45,
    y: 196.5,
    width: 115.84,
    height: 82.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.27
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 237.57999999999998
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.45,
    y: 278.66,
    width: 115.84,
    height: 96.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.028333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 326.745
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.45,
    y: 374.83,
    width: 115.84,
    height: 130.76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 440.21
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.45,
    y: 505.59,
    width: 115.84,
    height: 194.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.168
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.37,
    y: 602.795
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.29,
    y: 123.26,
    width: 140.09,
    height: 167.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.348333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.335,
    y: 207.25
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.38,
    y: 123.26,
    width: 166.87,
    height: 167.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.815,
    y: 207.25
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 506.24,
    y: 123.26,
    width: 193.76,
    height: 167.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 41.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.12,
    y: 207.25
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.29,
    y: 291.23,
    width: 188.69,
    height: 202.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.58625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.635,
    y: 392.64
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.29,
    y: 494.06,
    width: 188.69,
    height: 205.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.955714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.635,
    y: 597.03
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.98,
    y: 291.23,
    width: 155.68,
    height: 265.32,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.94666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.82000000000005,
    y: 423.89
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.66,
    y: 291.23,
    width: 156.34,
    height: 265.32,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 31.268
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.8299999999999,
    y: 423.89
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.98,
    y: 556.55,
    width: 312.02,
    height: 143.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.90833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.99,
    y: 628.275
  }, "\n        Nassau\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1988);
export default __webpack_public_path__ + "static/media/1988.2618c9d38a52124f2c7fae9d34a0231e.svg";
export { ForwardRef as ReactComponent };